/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShiftCounts} from '../api'

 export const useQueryGetShiftCounts = createReactQueryHook('getShiftCounts', getShiftCounts)
